import { Button, Card, CardActions, CardContent, LinearProgress, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { commons } from '../../commons';
import { formToObj, validateFormData } from '../../lib/validator';
import AuthService from '../../service/AuthService';
import { customStyles } from "../../styles/tableStyle"
import { profile } from '../../schema/formSchema/profile';
import { FormGenerator } from '../../lib';

function Profile(props) {
    const [loginData, setLoginData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        loadForm()
    }, []);



    const loadForm = async () => {
        let loginSchemaData = [...profile];
        if (props.type && props.type == "self") {
            let emailIndex = loginSchemaData.findIndex(item => item.key === "email");
            if (emailIndex > -1) {
                loginSchemaData[emailIndex].value = AuthService.getUserInfo().email
                loginSchemaData[emailIndex].disabled = true
            }
            let nameIndex = loginSchemaData.findIndex(item => item.key === "name");
            if (nameIndex > -1) {
                loginSchemaData[nameIndex].value = AuthService.getUserInfo().name
            }
        }
        setLoginData(loginSchemaData);
    };


    const submitProfile = async (event) => {
        event.preventDefault();
        let loginContent = [...loginData];
        let validFormData = await validateFormData(loginContent);
        setLoginData(validFormData)
        let result = validFormData.find(item => {
            if (item.error.length) return item;
        });


        if (!result) {
            setLoading(true)
            let params = await formToObj(validFormData);
            params.op = "setUser"
            params._id = AuthService.getUserInfo()._id
            delete params.email
            commons.getAPIRes(params, "POST", "user").then(userRes => {
                setLoading(false)
                if (userRes.status) {
                    alert(userRes.message)
                    localStorage.setItem("userInfo", JSON.stringify(userRes.result));
                    AuthService.setUserInfo(userRes.result)
                }
                else {
                    alert(userRes.message)
                }
            });
        }
        else {

        }
    };

    const handleChange = e => {
        let formDataInput = [...loginData];
        formDataInput.find(item => {
            if (item.key === e.target.name) {
                item.value = item.type === "number" ? parseInt(e.target.value) : e.target.value;
            }
        });
        setLoginData(formDataInput)
    };


    return (
        <Card>
            {loading ? <LinearProgress /> : false}
            <CardContent style={{ justifyContent: 'center' }}>
                <FormGenerator
                    formList={loginData}
                    editMode={true}
                    onChange={handleChange}
                />

            </CardContent>
            <CardActions style={{ justifyContent: 'end' }}>
                <Button onClick={props.closeDialog} disabled={loading} style={{ ...customStyles.submitBtn }} >Cancel </Button>
                <Button onClick={submitProfile} disabled={loading} style={{ ...customStyles.submitBtn }} > Submit </Button>
            </CardActions>
        </Card>
    );
}

export default Profile;
